module.exports = __webpack_public_path__ + "img/arrow.61f147f8.svg";